import { IPosition } from 'APIPackage/DictionariesModule/interfaces/IPosition';

import { makeCreateDictionarySelectOption } from './makeCreateDictionarySelectOption';

export const createDictionaryPositionSelectOption = makeCreateDictionarySelectOption<IPosition>('guid', 'title');
